import { EnumWithDescription, ICustomEnumValue } from "./EnumWithDescription";

export enum PalServiceLocationsEnum {
    TelehealthProvidedOutsidePatientsHome = 2 as any,
    School = 3 as any,
    HomelessShelter = 4 as any,
    Office = 11 as any,
    Home = 12 as any,
    AssistedLivingFacility = 13 as any,
    GroupHome = 14 as any,
    TemporaryLodging = 16 as any,
    WalkInRetailHealthClinic = 17 as any,
    PlaceOfEmploymentWorksite = 18 as any,
    OffCampusOutpatientHospital = 19 as any,
    UrgentCareFacility = 20 as any,
    InpatientHospital = 21 as any,
    OutpatientHospital = 22 as any,
    EmergencyDepartment = 23 as any,
    AmbulatorySurgicalCenter = 24 as any,
    BirthingCenter = 25 as any,
    SkilledNursingFacility = 31 as any,
    NursingFacility = 32 as any,
    CustodialCareFacility = 33 as any,
    IndependentClinic = 49 as any,
    FederallyQualifiedHealthCenter = 50 as any,
    InpatientPsychiatricFacility = 51 as any,
    PsychiatricFacilityPartialHospitalization = 52 as any,
    CommunityMentalHealthCenter = 53 as any,
    IntermediateCareFacilityIntellectualDisabilities = 54 as any,
    ComprehensiveInpatientRehabilitationFacility = 61 as any,
    ComprehensiveOutpatientRehabilitationFacility = 62 as any,
    EndStageRenalDiseaseTreatmentFacility = 65 as any,
    PublicHealthClinic = 71 as any,
    RuralHealthClinic = 72 as any
}
class PalServiceLocationsClass extends EnumWithDescription<PalServiceLocationsEnum> {
    public readonly enum = PalServiceLocationsEnum;
    public readonly enumName: string = "PalServiceLocationsEnum";

    public readonly enumWithDescriptions: Map<string, ICustomEnumValue<PalServiceLocationsEnum>> = new Map([
        [
            "TelehealthProvidedOutsidePatientsHome",
            {
                value: PalServiceLocationsEnum.TelehealthProvidedOutsidePatientsHome,
                name: "Telehealth Provided Outside Patient's Home"
            }
        ],
        [
            "School",
            {
                value: PalServiceLocationsEnum.School,
                name: "School"
            }
        ],
        [
            "HomelessShelter",
            {
                value: PalServiceLocationsEnum.HomelessShelter,
                name: "Homeless Shelter"
            }
        ],
        [
            "Office",
            {
                value: PalServiceLocationsEnum.Office,
                name: "Office"
            }
        ],
        [
            "Home",
            {
                value: PalServiceLocationsEnum.Home,
                name: "Home"
            }
        ],
        [
            "AssistedLivingFacility",
            {
                value: PalServiceLocationsEnum.AssistedLivingFacility,
                name: "Assisted Living Facility"
            }
        ],
        [
            "GroupHome",
            {
                value: PalServiceLocationsEnum.GroupHome,
                name: "Group Home"
            }
        ],
        [
            "TemporaryLodging",
            {
                value: PalServiceLocationsEnum.TemporaryLodging,
                name: "Temporary Lodging"
            }
        ],
        [
            "WalkInRetailHealthClinic",
            {
                value: PalServiceLocationsEnum.WalkInRetailHealthClinic,
                name: "Walk-in Retail Health Clinic"
            }
        ],
        [
            "PlaceOfEmploymentWorksite",
            {
                value: PalServiceLocationsEnum.PlaceOfEmploymentWorksite,
                name: "Place of Employment/Worksite"
            }
        ],
        [
            "OffCampusOutpatientHospital",
            {
                value: PalServiceLocationsEnum.OffCampusOutpatientHospital,
                name: "Off Campus Outpatient Hospital"
            }
        ],
        [
            "UrgentCareFacility",
            {
                value: PalServiceLocationsEnum.UrgentCareFacility,
                name: "Urgent Care Facility"
            }
        ],
        [
            "InpatientHospital",
            {
                value: PalServiceLocationsEnum.InpatientHospital,
                name: "Inpatient Hospital"
            }
        ],
        [
            "OutpatientHospital",
            {
                value: PalServiceLocationsEnum.OutpatientHospital,
                name: "Outpatient Hospital"
            }
        ],
        [
            "EmergencyDepartment",
            {
                value: PalServiceLocationsEnum.EmergencyDepartment,
                name: "Emergency Department"
            }
        ],
        [
            "AmbulatorySurgicalCenter",
            {
                value: PalServiceLocationsEnum.AmbulatorySurgicalCenter,
                name: "Ambulatory Surgical Center"
            }
        ],
        [
            "AmbulatorySurgicalCenter",
            {
                value: PalServiceLocationsEnum.AmbulatorySurgicalCenter,
                name: "Ambulatory Surgical Center"
            }
        ],
        [
            "BirthingCenter",
            {
                value: PalServiceLocationsEnum.BirthingCenter,
                name: "Birthing Center"
            }
        ],
        [
            "SkilledNursingFacility",
            {
                value: PalServiceLocationsEnum.SkilledNursingFacility,
                name: "Skilled Nursing Facility"
            }
        ],
        [
            "NursingFacility",
            {
                value: PalServiceLocationsEnum.NursingFacility,
                name: "Nursing Facility"
            }
        ],
        [
            "CustodialCareFacility",
            {
                value: PalServiceLocationsEnum.CustodialCareFacility,
                name: "Custodial Care Facility"
            }
        ],
        [
            "IndependentClinic",
            {
                value: PalServiceLocationsEnum.IndependentClinic,
                name: "Independent Clinic"
            }
        ],
        [
            "FederallyQualifiedHealthCenter",
            {
                value: PalServiceLocationsEnum.FederallyQualifiedHealthCenter,
                name: "Federally Qualified Health Center"
            }
        ],
        [
            "InpatientPsychiatricFacility",
            {
                value: PalServiceLocationsEnum.InpatientPsychiatricFacility,
                name: "Inpatient Psychiatric Facility"
            }
        ],
        [
            "PsychiatricFacilityPartialHospitalization",
            {
                value: PalServiceLocationsEnum.PsychiatricFacilityPartialHospitalization,
                name: "Psychiatric Facility-Partial Hospitalization"
            }
        ],
        [
            "IntermediateCareFacilityIntellectualDisabilities",
            {
                value: PalServiceLocationsEnum.IntermediateCareFacilityIntellectualDisabilities,
                name: "Intermediate Care Facility/Intellectual Disabilities"
            }
        ],
        [
            "ComprehensiveInpatientRehabilitationFacility",
            {
                value: PalServiceLocationsEnum.ComprehensiveInpatientRehabilitationFacility,
                name: "Comprehensive Inpatient Rehabilitation Facility"
            }
        ],
        [
            "ComprehensiveOutpatientRehabilitationFacility",
            {
                value: PalServiceLocationsEnum.ComprehensiveOutpatientRehabilitationFacility,
                name: "Comprehensive Outpatient Rehabilitation Facility"
            }
        ],
        [
            "EndStageRenalDiseaseTreatmentFacility",
            {
                value: PalServiceLocationsEnum.EndStageRenalDiseaseTreatmentFacility,
                name: "End-Stage Renal Disease Treatment Facility"
            }
        ],
        [
            "PublicHealthClinic",
            {
                value: PalServiceLocationsEnum.PublicHealthClinic,
                name: "Public Health Clinic"
            }
        ],
        [
            "RuralHealthClinic",
            {
                value: PalServiceLocationsEnum.RuralHealthClinic,
                name: "Rural Health Clinic"
            }
        ]
    ]);
}

export const PalServiceLocations = new PalServiceLocationsClass();
